/**
 * ProtectedAdminRoute v1.0 (2026-09-15) — the one superadmin route wrapper.
 * Moved out of App.tsx unchanged in behaviour so the render decision (AdminRouteGate)
 * can be checked on its own. Admin is public.user_roles via useSuperadmin().
 */
import type { ReactNode } from "react";
import { useSuperadmin } from "@/hooks/useSuperadmin";
import { AdminRouteGate } from "@/components/auth/AdminRouteGate";

export function ProtectedAdminRoute({ children }: { children: ReactNode }) {
  const { isSuperadmin, loading } = useSuperadmin();
  return (
    <AdminRouteGate isSuperadmin={isSuperadmin} loading={loading}>
      {children}
    </AdminRouteGate>
  );
}

export default ProtectedAdminRoute;
